<template>
	 <div  :style="`backgroundColor:${ui.bg_color};width: 100%;`">
          <div class="main_form main_form_second">
            <p class="lable_p" v-if="is_name"  :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#fff'}">您的姓名</p>
            <van-field
                v-if="is_name" 
                v-model="action_form.name"
                name="姓名"
                placeholder="请输入您的姓名"
                class="custom_field"
            />

            <p class="lable_p"   :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#fff'}">您的手机号码(已加密)</p>
            <van-field
                type="tel"
                v-model="action_form.phone"
                name="电话"
                placeholder="请输入您的手机号码"
                class="custom_field"
            />

            <template v-if="is_show_car">
              <p class="lable_p"   :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#fff'}">选择您的意向车型</p>
              <van-field
                  v-model="action_form.car_name"
                  readonly
                  placeholder="意向车型（品牌+厂商+车型）"
                  @click="openCarDialog"
                  class="custom_field"
              >
                <template slot="right-icon">
                  <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
                </template>
              </van-field>
            </template>
            <!--          v-if="is_city"-->
            <p class="lable_p" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#fff'}" v-if="is_city">您所在的城市</p>
            <van-field
                v-model="action_form.city"
                readonly
                placeholder="选择您所在的城市"
                @click="openCityDialog"
                class="custom_field"
                v-if="is_city"
            >
              <template slot="right-icon">
                <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
              </template>
            </van-field>

            <div class="main_form_btn">
              <div class="form_btn mt_20" @click="submitForm" :style="`backgroundColor: ${ui.btn_bg_color};`">
                <span  :style="`color: ${is_opacity}`">{{ui.btn_text}}</span>
                <img src="../../assets/image/new_img/pointer_02.png" alt="" class="form_pointer finger_swing" style="z-index: 30">
              </div>
            </div>
            <div class="form_policy">
              <policy :custom_col='ui.bg_color == "#FFFFFF" ? "#232323" :"#fff"'></policy>
            </div>
          </div>
      </div>
</template>

<script>
import policy from "@/components/policy.vue";
export default {
		name:"FormFour",
    components: {
      policy,
    },
		data(){
			return{
    // is_name:true //是否显示姓名
			}
		},
		props: {
			ui: {
				type: Object,
			},
			is_opacity: {
				type: String,
			},
			is_city: {
				type: Boolean,
			},
			action_form: {
				type: Object,
			},
			
      is_opacity: {
				type: String,
			},
      is_show_car: {
        type: Boolean,
        default: true
      },
      tid:{
          type: Number,
          default: 0
        },
      title:{
        type: String,
        default: ''
      },
      is_name:{
        type: Boolean,
        default: true
      }
		},
		methods: {
			submitForm(){
				this.$emit('submitForm')
			},
			 openCarDialog() {
        this.$emit("openCarDialog");
      },
      openCityDialog() {
        this.$emit("openCityDialog");
      },
		},
    watch: {
    // title(v) {
    //   this.is_name = !(this.title.indexOf('家博会')>-1 && this.tid == 5)
    //   console.log(this.is_name);
    // },
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/base_form.less";
</style>